import { DataPackSyncQueue } from './dataPackSyncQueue.model';

/**
 * @version $Id$
 */
export class DataPackSyncControl {

    public reqId: number;
    public extAcc: string;
    public totalSent: number;
    public totalProcess: number;
    public operation: String;
    public queueList: Array<DataPackSyncQueue>;

    constructor(){
        this.queueList = new Array<DataPackSyncQueue>();
    }
}


// WEBPACK FOOTER //
// ./src/app/models/dataPackSyncControl.model.ts